<div class="card card-body col-lg-12">
    <div class="row">
        <div class="col-lg-3 form-group">
            <label>Reporting Member Name</label>
            <input type="text" class="form-control form-control-sm" formControlName="reportingMemName" readonly>
        </div>
        <div class="col-lg-3 form-group">
            <label>Reporting Member Id</label>
            <input type="text" class="form-control form-control-sm" formControlName="reportingMemId" readonly>
        </div>
    </div>
</div>